import { Bubble } from "components/atoms";
import styled from "styled-components";

const BubblesContainer = styled.div`
  > *:nth-child(1) {
    width: 30px;
    height: 30px;
    left: 60%;
    bottom: 30px;
    animation-delay: -13.75s;
    animation-duration: 20s;
    opacity: 0.3;
  }

  > *:nth-child(2) {
    width: 15px;
    height: 15px;
    left: 40%;
    animation-delay: 1s;
    animation-duration: 10s;
    opacity: 0.1;
  }

  > *:nth-child(3) {
    width: 10px;
    height: 10px;
    left: 30%;
    top: 5%;
    animation-delay: 5s;
    animation-duration: 17s;
    opacity: 0.3;
  }

  > *:nth-child(4) {
    width: 25px;
    height: 25px;
    left: 90%;
    bottom: 30px;
    animation-delay: -10.5s;
    animation-duration: 19s;
    opacity: 0.3;
  }

  > *:nth-child(5) {
    width: 25px;
    height: 25px;
    left: 40%;
    top: 15%;
    animation-delay: 8s;
    animation-duration: 17s;
    opacity: 0.2;
  }

  > *:nth-child(6) {
    width: 30px;
    height: 30px;
    left: 60%;
    top: 35%;
    animation-delay: 10s;
    animation-duration: 15s;
    opacity: 0.1;
  }

  > *:nth-child(7) {
    width: 15px;
    height: 15px;
    left: 90%;
    animation-delay: -7s;
    animation-duration: 19s;
    opacity: 0.3;
  }

  > *:nth-child(8) {
    width: 12px;
    height: 12px;
    left: 25%;
    bottom: 50px;
    animation-delay: -3s;
    animation-duration: 18s;
    opacity: 0.4;
  }

  > *:nth-child(9) {
    width: 20px;
    height: 20px;
    left: 50%;
    bottom: 30px;
    animation-delay: -4s;
    animation-duration: 15s;
    opacity: 0.2;
  }

  > *:nth-child(10) {
    width: 40px;
    height: 40px;
    left: 30%;
    bottom: 30px;
    animation-delay: -10s;
    animation-duration: 12s;
    opacity: 0.3;
  }
`;

const getBubbles = () => {
  const bubblesAmount = 10;
  const bubbles = [];
  for (let i = 0; i < bubblesAmount; i++) {
    bubbles.push(<Bubble key={i.toString()} />);
  }

  return bubbles;
};

export const Bubbles = () => {
  const bubbles = getBubbles();
  return <BubblesContainer>{bubbles.map((bubble) => bubble)}</BubblesContainer>;
};
